import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=1cfb8bdf&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=1cfb8bdf&prod&lang=scss&scoped=true&"
import style1 from "./MainFooter.vue?vue&type=style&index=1&id=1cfb8bdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb8bdf",
  null
  
)

export default component.exports